import React from 'react';
import { Button, ButtonProps } from 'antd';

import './style.less';

const DeleteButton: React.FC<ButtonProps> = (props) => (
  <Button className="delete-button" {...props} />
);

export default DeleteButton;
